import React from 'react';

const AttendeLiveAnswer:React.FC<{
  alphabet:string;
  answer: string;
  answerLength: number;
  totalAnswers?: number;
  totalAnswersAggregate?: number;
  value?: boolean;
}> = ({ alphabet, answer, answerLength, totalAnswers, value, totalAnswersAggregate }) => {
  const padClass = answerLength > 3 ? 'padClassActive' : '';

  // assign correct/wrong css class to tile
  const ansClass = () => {
    if(totalAnswers?.toString()) {
      return value ? 'correct-ans' : 'wrong-ans'
    } else {
      return 'correct-ans'
    }
  }

  return (
    <div className={`quiz-live-answer-comp ${padClass} ${ansClass()}`}>
      <div className="att-ans-comp att-ans-comp-flex">
        <span className="alpha" >{alphabet} { value ? (<img height={35} width={35} style={{marginTop:'10px'}} className="correct-ans-img" src="/icons/ans-correct.svg" alt="" />):
          <img height={35} width={35} style={{marginTop:'10px'}} className="wrong-ans-img" src="/icons/wrong-ans.svg" alt="" />}</span>
        <p className="" style={{color:'white'}}>{answer}</p>
      </div>

    </div>
  )
}

export default AttendeLiveAnswer
